<div class="restaurant-header">
  <!-- Logo azienda a sinistra -->
  <a class="mobile-header__logo" routerLink="menu">
    <img *ngIf="logo" [src]="logo" alt="Logo azienda" class="azienda-logo-icon-small" style="object-fit: contain;">
    <span *ngIf="!logo" class="azienda-label-small">{{ nome }}</span>
  </a>

  <!-- Sezione icone a destra -->
  <div class="restaurant-header__indicators" >
  

    <!-- Lingua -->
      <div class="language-switcher">
        <span 
          class="language-option" 
          [class.active]="currentLang === 'it'" 
          (click)="changeLang('it')">
          IT
        </span>
        |
        <span 
          class="language-option" 
          [class.active]="currentLang === 'en'" 
          (click)="changeLang('en')">
          EN
        </span>
      </div>

        <!-- Icona carrello -->
    <a *ngIf="cartService.isCheckoutAvailable()" [routerLink]="['/shop/cart']" class="indicator__button">
      <span class="indicator__area">
        <app-icon name="cart-20" size="20"></app-icon>
        <span class="indicator__value">{{ cartCount$ | async }}</span>
      </span>
    </a>

  </div>
</div>